<app-header></app-header>

<ion-content scrollbar class="ion-no-padding">
  <!-- SALKI -->
  <ng-container *ngIf="valueC === 'rooms'">
    <div class="room__padding">
      <app-select-with-images
        *ngIf="!isSpinner"
        [defaultImage]="'../assets/icons/room-plug.svg'"
        [displayItems]="spaceService.spaces"
        [isImagesDisplay]="false"
        name="BOOKING.CHOOSE_ROOM"
        placeholder="BOOKING.ROOM_NAME"
        itemValueField="id"
        itemTextField="name"
        (changeValue)="roomSelected($event)"
        editLink="/app/booking/room-details/"
        [itemsObservable]="spacesChangedSubject.asObservable()"
        [initBuilding]="initBuilding"
      ></app-select-with-images>
    </div>
  </ng-container>

  <!-- MOJE REZERWACJE -->
  <ng-container *ngIf="valueC === 'events'">
    <div class="room__padding">
      <ion-fab
        *ngIf="p.renderMobile"
        vertical="bottom"
        horizontal="end"
        slot="fixed"
        class="room__add-btn"
      >
        <ion-fab-button (click)="onReroute()">
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>
      </ion-fab>
      <app-list-header (toggleFilter)="onToggleFilter()">
        <ng-container top>
          <app-search-bar
            #searchBar
            class="w-100"
            (searchEvent)="bookingRowsLoaderInit()"
            [permissionEdit]="true"
            buttonAddLabel="{{ 'SPACE.CHECK_AVAILABILITY' | translate}}"
            (addClickEvent)="onReroute()"
            [onAddClickEvent]="true"
          >
          </app-search-bar>
        </ng-container>
        <ng-container bottom>
          <div
            class="display-flex align-items-center ion-justify-content-end"
            *ngIf="!p.renderMobile"
          >
            <ion-label class="ion-text-end">
              {{ "SPACE.SHOW_ALL_RESERVATIONS" | translate }}
            </ion-label>
            <ion-toggle
              (ionChange)="onToggleReservationList()"
              [checked]="showAllReservations"
            ></ion-toggle>
          </div>
        </ng-container>
      </app-list-header>

      <app-pagination-client-side
        [ngClass]="{'height-0': showLoader}"
        [columns]="columnsDefinitionBookings"
        [componentRef]="componentRefBooking"
        [options]="options"
        (rowsLoaderReady)="bookingRowsLoaderServiceReady($event)"
      ></app-pagination-client-side>

      <div class="spin" *ngIf="showLoader">
        <app-loading-sti></app-loading-sti>
      </div>
    </div>
  </ng-container>

  <!-- EDYCJA SALEK  -->
  <ng-container *ngIf="valueC === 'edit'">
    <ng-container *ngIf="p.renderMobile">
      <ion-fab
        *appHasRole="['room.add']"
        vertical="bottom"
        horizontal="end"
        slot="fixed"
      >
        <ion-fab-button>
          <ion-icon name="add"></ion-icon>
        </ion-fab-button>

        <ion-fab-list side="top" class="room__floating-buttons-container">
          <ion-button routerLink="/app/booking/add-room">
            <ion-icon slot="start" name="add"></ion-icon>
            {{ "SPACE.ROOM.ADD" | translate }}
          </ion-button>
          <ion-button routerLink="/app/equipment/1" color="medium">
            <ion-icon slot="start" name="add"></ion-icon>
            {{ "SPACE.ROOM.EQUIPMENT_M" | translate }}
          </ion-button>
        </ion-fab-list>
      </ion-fab>
    </ng-container>

    <app-space-list
      spaceAddRole="room.add"
      [spaceType]="spaceType"
      addLink="/app/booking/add-room"
      routerLinkBase="/app/booking/room-details"
      addButtonLabel="SPACE.ROOM.ADD"
      [withAssignment]="true"
    ></app-space-list>
  </ng-container>
</ion-content>
